import React from "react";

const NotFound = () => (
  <p>Page does not found...</p>
)

export default NotFound;